import React, { useEffect, useRef } from "react";
import TableUi from "./TableUi";
import $ from "jquery";
import "datatables.net-bs4";
import CustomToast from "../CustomToast/CustomToast";
function Table({
  columns, // Array of column definitions
  data, // Array of table data
  pagination, // Pagination configuration
  onPageChange, // Function to handle page changes
  msg
}) {
  const tableRef = useRef(null); // Creating a ref for the table

  useEffect(() => {
    // Initialize DataTable when the component mounts
    const dataTable = $(tableRef.current).DataTable({
        paging: true,
        lengthChange: false,
        searching: false,
        ordering: true,
        info: true,
        autoWidth: true,
        responsive: true,
        pageLength:10
    });
    // Cleanup function to destroy DataTable when the component unmounts
    return () => {
      dataTable.destroy();
    };
  }, []);
  return (
    <>
   
      <TableUi
        columns={columns}
        data={data}
        pagination={pagination}
        onPageChange={onPageChange}
        msg={msg}
      />
    </>
  );
}

export default Table;
